import { render, staticRenderFns } from "./ByVersion.vue?vue&type=template&id=e6c861e8&scoped=true"
import script from "./ByVersion.vue?vue&type=script&lang=js"
export * from "./ByVersion.vue?vue&type=script&lang=js"
import style0 from "./ByVersion.vue?vue&type=style&index=0&id=e6c861e8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c861e8",
  null
  
)

export default component.exports